export const landing = {
  tryNowBtn: "Попробовать сейчас",
};
